











































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import noUiSlider from 'nouislider';
import VirtualMachineHardwareSummary from '@/components/virtual-machine-edit/VirtualMachineHardwareSummary.vue';
import TooltipBox from '@/components/common/TooltipBox.vue';
import { limitsService } from '@/services/LimitsService';
import { mapState } from 'vuex';
import { storeService } from '@/services/StoreService';
import { virtualMachineDetailsService } from '@/components/virtual-machine-edit/services/VirtualMachineDetailsService';

@Component({
  props: ['virtualMachine'],
  components: {
    VirtualMachineHardwareSummary,
    TooltipBox,
  },
  computed: {
    ...mapState({
      userRole: (state: any) => state.currentWorkspace.role,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class VirtualMachineHardware extends Vue {
  workspaceId = 0;
  regionId = 0;
  virtualMachineId = 0;
  resources: any = {};
  hardwareData: any = {};
  currentData: any = {};
  param = '';
  rest: any = {};
  limits: any = {};
  currentUsage: any = {};
  additionalDisksStorage: number = 0;
  snapshot = {};
  isRestartNeeded = false;

  // @Watch('currentData', { immediate: true, deep: true })
  // onCurrentDataChange(data: any) {
  //   if (!this.currentData.ram || this.currentData.ram < 1) {
  //     this.resetParam('ram');
  //   }
  //   if (!this.currentData.cpu_cores || this.currentData.cpu_cores < 1) {
  //     this.resetParam('cpu');
  //   }
  // }

  @Watch('$props.virtualMachine.state')
  onMachineStateChanged() {
    this.updateSlidersState();
  }

  @Watch('$store.state.virtualMachines.virtualMachineHardware', { immediate: true, deep: true })
  onMachinesChange() {
    if (this.virtualMachineId) {
      const vmHardware = this.$store.getters['virtualMachines/getMachineHardware'](this.virtualMachineId);
      if (vmHardware) {
        this.hardwareData = JSON.parse(JSON.stringify(vmHardware));
        this.currentData = vmHardware;
        this.resources = vmHardware.resources;
        this.initSliders(true);
        this.getLimits();
      }
    }
  }

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.virtualMachineId = parseInt(this.$route.params.virtualMachineId, 10);
    this.getHardwareData();
    this.getLimits();
    this.getSnap();
  }

  showRestartInfo() {
    if (
      (this.$props.virtualMachine.state === 'on' || this.$props.virtualMachine.state === 'suspended') &&
      (this.hardwareData.cpu_cores !== this.currentData.cpu_cores || this.hardwareData.ram !== this.currentData.ram)
    ) {
      this.isRestartNeeded = true;
    } else {
      this.isRestartNeeded = false;
    }
  }

  getSnap() {
    virtualMachineDetailsService
      .getSnapshot(this.workspaceId, this.regionId, this.virtualMachineId)
      .then((data: any) => {
        this.snapshot = data;
      });
  }

  resetParam(param: string) {
    if (param === 'cpu') {
      this.updateSlider('cpuSlider', this.hardwareData.cpu_cores);
    } else if (param === 'ram') {
      this.updateSlider('ramSlider', this.hardwareData.ram);
    } else if (param === 'primary_disk') {
      this.updateSlider('primaryDiskSlider', this.hardwareData.primary_disk.size);
    }
  }

  resetAdditionalDisk(index: string) {
    if (this.hardwareData.additional_disks[index].size === 0) {
      this.currentData.additional_disks[index].size = parseInt(this.resources.additional_disk.min, 10);
    } else {
      this.currentData.additional_disks[index].size = parseInt(this.hardwareData.additional_disks[index].size, 10);
    }

    this.initSliders();
  }

  addAdditionalDisk() {
    if (this.hardwareData.additional_disks.length < this.hardwareData.max_additional_disks) {
      this.hardwareData.additional_disks.push({
        id: new Date().getTime(),
        size: 0,
        type: 'hdd',
        isNew: true,
      });
      this.currentData.additional_disks.push({
        id: new Date().getTime(),
        size: this.resources.additional_disk.min,
        type: 'hdd',
        isNew: true,
      });
      this.initSliders();
    }
  }

  deleteAdditionalDisk(index: number) {
    this.currentData.additional_disks[index].size = 0;
    this.initSliders();
  }

  removeAdditionalDisk(index: number) {
    this.hardwareData.additional_disks.splice(index, 1);
    this.currentData.additional_disks.splice(index, 1);
    this.initSliders();
  }

  updateSlidersState() {
    const sliders = ['cpuSlider', 'ramSlider', 'primaryDiskSlider'];
    this.currentData.additional_disks.map((disk: any, index: any) => {
      sliders.push(`additionalDisk${disk.id}`);
    });
    for (let sliderName of sliders) {
      let slider = this.getSlider(sliderName);
      if (slider) {
        if (
          !this.$store.state.currentWorkspace.role ||
          this.$store.state.currentWorkspace.role === 'read_only' ||
          this.$props.virtualMachine.state === 'busy' ||
          this.$props.virtualMachine.state === 'suspended' ||
          this.$props.virtualMachine.state === 'error'
        ) {
          slider.setAttribute('disabled', 'disabled');
        } else {
          slider.removeAttribute('disabled');
        }
      }
    }
  }

  getSlider(ref: any) {
    const slider = (this.$refs[ref] as any)[0] || (this.$refs[ref] as any);
    return slider && slider.removeAttribute ? slider : null;
  }

  updateSlider(ref: any, value: number) {
    const slider = (this.$refs[ref] as any)[0] || (this.$refs[ref] as any);
    if (slider.noUiSlider) {
      slider.noUiSlider.updateOptions({
        start: [value],
      } as any);
    }
  }

  createSlider(ref: any, value: number, options: any, isHardInit = false) {
    const slider = (this.$refs[ref] as any)[0] || (this.$refs[ref] as any);
    if (!slider || Array.isArray(slider)) {
      return { on: () => {} };
    }
    const paddingLeft = options.padding + options.min >= options.max ? 0 : options.padding;
    if (slider.noUiSlider) {
      slider.noUiSlider.updateOptions({
        start: [value],
        range: { min: options.min, max: options.max },
      });
      if (isHardInit) {
        slider.noUiSlider.updateOptions({
          padding: [paddingLeft ? paddingLeft : 0, 0],
        } as any);
      }
    } else {
      noUiSlider.create(slider, {
        start: [value],
        padding: [paddingLeft ? paddingLeft : 0, 0],
        connect: [true, false],
        range: { min: options.min, max: options.max },
        step: 1,
      } as any);
    }
    return slider.noUiSlider;
  }

  getLimits() {
    limitsService.getLimits(this.workspaceId, this.regionId).then((data: any) => {
      this.limits = data;
      limitsService.getCurrentUsage(this.workspaceId, this.regionId).then((data: any) => {
        this.currentUsage = data;
        ['cpu_cores', 'ram', 'storage', 'public_networks'].map(item => {
          this.rest[item] = this.limits[item] - this.currentUsage[item] + (this.hardwareData[item] || 0);
          if (item === 'storage' && !!this.hardwareData.primary_disk) {
            this.rest[item] += this.hardwareData.primary_disk.size;
            this.rest[item] += this.hardwareData.additional_disks.reduce((prev: any, item: any) => item.size + prev, 0);
          }
        });
        this.rest = { ...this.rest };
      });
    });
  }

  createDynamicSlider(id: number, index: number, value: number, isHardInit = false) {
    this.$nextTick().then(() => {
      this.createSlider(
        `additionalDisk${id}`,
        value,
        {
          ...this.resources.additional_disk,
          padding: (value || 0) - this.resources.additional_disk.min,
        },
        isHardInit
      ).on('update', (value: any) => {
        this.additionalDisksStorage = 0;
        this.currentData.additional_disks[index].size = parseInt(value || '0', 10);
        for (let additionalDisk of this.currentData.additional_disks) {
          this.additionalDisksStorage += additionalDisk.size || 0;
        }
      });
    });
  }

  initSliders(isHardInit = false) {
    this.$nextTick().then(() => {
      if (!this.resources.cpu) {
        return;
      }
      const resources = {
        cpu: {
          min: this.resources.cpu.min,
          max: this.resources.cpu.max,
          padding: 0,
          price: {
            cents: this.resources.cpu.price ? this.resources.cpu.price.cents : 0,
            currency: this.resources.cpu.price ? this.resources.cpu.price.currency : '',
          },
        },
        ram: {
          min: this.resources.ram.min,
          max: this.resources.ram.max,
          padding: 0,
          price: {
            cents: this.resources.ram.price.cents,
            currency: this.resources.ram.price.currency,
          },
        },
        primary_disk: {
          min: this.resources.primary_disk.min,
          padding: this.hardwareData.primary_disk.size - this.resources.primary_disk.min,
          max: this.resources.primary_disk.max,
          price: {
            hdd: {
              cents: this.resources.primary_disk.price.hdd.cents,
              currency: this.resources.primary_disk.price.hdd.currency,
            },
            ssd: {
              cents: this.resources.primary_disk.price.ssd.cents,
              currency: this.resources.primary_disk.price.ssd.currency,
            },
          },
        },
        additional_disk: {
          min: this.resources.additional_disk.min,
          max: this.resources.additional_disk.max,
          padding: 0,
          price: {
            hdd: {
              cents: this.resources.additional_disk.price.hdd.cents,
              currency: this.resources.additional_disk.price.hdd.currency,
            },
            ssd: {
              cents: this.resources.additional_disk.price.ssd.cents,
              currency: this.resources.additional_disk.price.ssd.currency,
            },
          },
        },
      };
      this.createSlider('cpuSlider', this.currentData.cpu_cores, resources.cpu).on('update', (value: any) => {
        this.currentData.cpu_cores = parseInt(value, 10);
        this.showRestartInfo();
      });
      this.createSlider('ramSlider', this.currentData.ram, resources.ram).on('update', (value: any) => {
        this.currentData.ram = parseInt(value, 10);
        this.showRestartInfo();
      });
      this.createSlider('primaryDiskSlider', this.currentData.primary_disk.size * 1, resources.primary_disk).on(
        'update',
        (value: any) => {
          this.currentData.primary_disk.size = parseInt(value, 10);
        }
      );
      this.currentData.additional_disks.map((disk: any, index: any) => {
        if (disk.size === '') {
          // this.resetAdditionalDisk(index);
        }
        this.createDynamicSlider(disk.id, index, disk.size || 0, isHardInit);
      });
      this.updateSlidersState();
    });
  }

  getHardwareData() {
    storeService.getVirtualMachineHardware(this.virtualMachineId, true);
  }
}
